// TODO(A): khoá học / chứng chỉ thật khi có dữ liệu. Số MẪU theo script board Mint-Training (COURSES · SUG · CERT), neo 22/Oct/2026.

export interface Course {
  id: number;
  k: string;
  short: string;
  cat: string;
  required: boolean;
  done: number;
  total: number;
  minutes: number;
  quiz: number;
  due: string;
  dueSub: string;
  /** số ngày làm việc tới hạn (âm = quá hạn), null = tự chọn / đã xong */
  dd: number | null;
  late: boolean;
  passed: boolean;
  tries: number[];
  /** đường vẽ icon khoá (viewBox 24) */
  icon: string;
  /** mô tả ngắn (tooltip cột Nội dung) */
  sub: string;
}

export const COURSES: readonly Course[] = [
  { id: 0, k: 'Gửi bill qua hệ thống: Draft → Final → Release', short: 'Gửi bill qua hệ thống', cat: 'SOP · Chứng từ & B/L', required: true, done: 3, total: 6, minutes: 18, quiz: 10, due: '24/Oct/2026', dueSub: 'còn 2 ngày làm việc', dd: 2, late: false, passed: false, tries: [], icon: 'M7 3h8l4 4v14H7z M15 3v4h4 M10 12h6 M10 16h6', sub: '6 bài · 18 phút · quiz 10 câu sinh từ SOP-CS-07' },
  { id: 1, k: 'Release B/L khi khách còn nợ — đường duyệt theo mức nợ', short: 'Release B/L theo mức nợ', cat: 'SOP · Tài chính', required: true, done: 0, total: 4, minutes: 12, quiz: 8, due: '21/Oct/2026', dueSub: 'quá hạn 1 ngày', dd: -1, late: true, passed: false, tries: [], icon: 'M3 7h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3z M3 7V5h13 M16 13.5h.01', sub: '4 bài · 12 phút · bắt buộc cho SALE-MGR, CS' },
  { id: 2, k: 'Báo giá Live: margin theo tuyến và gửi hàng loạt', short: 'Báo giá Live', cat: 'Hướng dẫn · Kinh doanh', required: true, done: 5, total: 5, minutes: 9, quiz: 8, due: '30/Oct/2026', dueSub: 'chờ làm bài kiểm tra', dd: 6, late: false, passed: false, tries: [64], icon: 'M20 12 12 20 4 12V4h8z M8.5 8.5h.01', sub: '5 bài · video 9 phút · quiz 8 câu' },
  { id: 3, k: 'Kiêm nhiệm & luật người làm ≠ người duyệt', short: 'Kiêm nhiệm & luật duyệt', cat: 'Quy định nội bộ', required: false, done: 2, total: 3, minutes: 7, quiz: 5, due: '—', dueSub: 'tự chọn', dd: null, late: false, passed: false, tries: [], icon: 'M12 3l8 4v6c0 4-3.5 7-8 8-4.5-1-8-4-8-8V7z M9 12l2 2 4-4', sub: '3 bài · 7 phút' },
  { id: 4, k: 'Tư vấn mã HS & chọn form C/O theo FTA', short: 'Tư vấn HS & form C/O', cat: 'Hướng dẫn · Hải quan', required: false, done: 6, total: 6, minutes: 25, quiz: 6, due: '15/Oct/2026', dueSub: 'đạt 92% · có chứng chỉ', dd: null, late: false, passed: true, tries: [72, 92], icon: 'M2 9l10-5 10 5-10 5z M6 11v5c3 2 9 2 12 0v-5', sub: '6 bài · 25 phút' },
];

export type Viewer = 'DAVID' | 'MAITTN';

export interface Learner {
  k: Viewer;
  seat: string;
  /** quyền quản lý đào tạo theo ghế (HR / trưởng phòng) */
  manager: boolean;
}

export const LEARNERS: Record<Viewer, Learner> = {
  DAVID: { k: 'DAVID', seat: 'SALE-MGR', manager: true },
  MAITTN: { k: 'MAITTN', seat: 'CSD-CSO', manager: false },
};

export interface Suggestion {
  k: string;
  minutes: number;
  icon: string;
}

const WARN = 'M12 9v4 M12 17h.01 M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z';
const CAL = 'M4 6h16v14H4z M4 10h16 M8 3v4 M16 3v4';
const DOC = 'M7 3h8l4 4v14H7z M15 3v4h4';

/** Gợi ý theo lộ trình của ghế đang giữ, bỏ khoá đã có. */
export const SUGGESTIONS: Record<Viewer, readonly Suggestion[]> = {
  DAVID: [{ k: 'Xử lý cargo claim', minutes: 15, icon: WARN }, { k: 'DEM/DET & báo khách', minutes: 12, icon: CAL }, { k: 'Cập nhật SOP mới · quý 4', minutes: 5, icon: DOC }],
  MAITTN: [{ k: 'DEM/DET & báo khách', minutes: 12, icon: CAL }, { k: 'Release B/L theo mức nợ', minutes: 12, icon: COURSES[1]!.icon }, { k: 'Xử lý cargo claim', minutes: 15, icon: WARN }],
};

export type CertStatus = 'ok' | 'soon' | 'exp';

export interface Certificate {
  owner: string;
  seat: string;
  k: string;
  source: 'Nội bộ' | 'Bên ngoài';
  issued: string;
  expires: string;
  status: CertStatus;
  /** số ngày còn lại tới hạn (chỉ có khi sắp hết / đã hết hạn) */
  days?: number;
}

export const CERTS: readonly Certificate[] = [
  { owner: 'DAVID', seat: 'SALE-MGR', k: 'Đại lý hải quan (Tổng cục HQ)', source: 'Bên ngoài', issued: '12/Mar/2023', expires: '11/Nov/2026', status: 'soon', days: 18 },
  { owner: 'HANHLTM', seat: 'ACC-CP', k: 'Kế toán trưởng (Bộ Tài chính)', source: 'Bên ngoài', issued: '04/Jun/2022', expires: '04/Jun/2027', status: 'ok' },
  { owner: 'THANHTTK', seat: 'TRD-DSP', k: 'Điều độ vận tải nội bộ', source: 'Nội bộ', issued: '20/Jan/2026', expires: '20/Jan/2027', status: 'ok' },
  { owner: 'CongNV', seat: 'TRD-DRV', k: 'Bằng lái FC', source: 'Bên ngoài', issued: '02/Feb/2021', expires: '30/Oct/2026', status: 'soon', days: 6 },
  { owner: 'ThaoTN', seat: 'TRD-DRV', k: 'An toàn lái xe container đêm', source: 'Nội bộ', issued: '05/Apr/2026', expires: '05/Oct/2026', status: 'exp', days: 0 },
  { owner: 'MAITTN', seat: 'CSD-CSO', k: 'Tư vấn HS & form C/O', source: 'Nội bộ', issued: '15/Oct/2026', expires: '15/Oct/2028', status: 'ok' },
  { owner: 'PhuongHT', seat: 'CSD-BKG', k: 'FIATA Diploma module 1', source: 'Bên ngoài', issued: '10/Aug/2025', expires: '—', status: 'ok' },
];
